export default __webpack_public_path__ + "static/media/categoriesimage.b5e6ba13.png";